import { customElement, autoinject, bindable } from 'aurelia-framework';
import { InputBase } from '../inputBase';

@customElement('input-checkbox')
@autoinject()
export class InputCheckbox extends InputBase<boolean> {
    @bindable disabled: boolean = false;
}
